import React, { useState } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { GetAll } from "../../../util/request/getAll";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PaymentRequest = (props) => {
  const [open, setOpen] = useState(false);
  const [sendEmail, setSendEmail] = useState(true);
  const [sendSMS, setSendSMS] = useState(false);
  const [email, setEmail] = useState(
    props.eventData.bookingDetail.email == "None"
      ? ""
      : props.eventData.bookingDetail.email
  );
  const [phoneNumber, setPhoneNumber] = useState(
    props.eventData.bookingDetail.phone_number == "None"
      ? ""
      : props.eventData.bookingDetail.phone_number
  );

  console.log(sendEmail, sendSMS);
  console.log(email, phoneNumber);
  const handleOpen = () => {
    setOpen(true);
    setEmail(
      props.eventData.bookingDetail.email == "None"
        ? ""
        : props.eventData.bookingDetail.email
    );
    setPhoneNumber(
      props.eventData.bookingDetail.phone_number == "None"
        ? ""
        : props.eventData.bookingDetail.phone_number
    );
  };

  const handleClose = () => setOpen(false);

  const handleSubmit = async () => {
    const result = await GetAll({
      subLink: `booking/emailInitialDepositPaymentLink?id=${props.eventData._id}&&sms=${sendSMS}&&email=${sendEmail}&&phone_number=1${phoneNumber}&&email_address=${email}`,
    });
    setOpen(false);
  };
  //   subLink: "booking",
  //   id: props.eventData._id,
  //   data: {
  //     booking_status: "completed",
  //   },
  // });
  // if (result.status === "success") {
  //   props.reFreshData();

  //   setOpen(false);
  // }

  // handleClose();

  return (
    <div>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{ maxWidth: "200px" }}
        color="success"
      >
        Deposit request
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Stack justifyContent="flex-end">
            <Typography
              variant="h6"
              component="h4"
              sx={{ flexGrow: 1, marginBottom: "10px" }}
            >
              Send deposit request link to{" "}
            </Typography>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    // defaultChecked
                    checked={sendEmail}
                    onChange={(e) => setSendEmail(e.target.checked)}
                  />
                }
                label="Email"
              />
              <TextField
                variant="standard"
                value={email}
                sx={{ minWidth: "250px", mb: "30px" }}
                onChange={(e) => setEmail(e.target.value)}
              />
              <FormControlLabel
                control={
                  <Switch
                    disabled
                    // checked={sendSMS}
                    // onChange={(e) => setSendSMS(e.target.checked)}
                  />
                }
                label="SMS"
              />
              <TextField
                variant="standard"
                value={phoneNumber}
                sx={{ minWidth: "250px", mb: "30px" }}
                onChange={(e) =>
                  setPhoneNumber(e.target.value.replace(/\D/g, "").slice(0, 10))
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">+1</InputAdornment>
                  ),
                }}
                inputProps={{ inputMode: "tel" }}
              />
            </FormGroup>
            <Stack direction="row" justifyContent="flex-end">
              <Button
                variant="outlined"
                fullWidth
                onClick={handleClose}
                sx={{ maxWidth: "100px", mr: "50px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                fullWidth
                onClick={handleSubmit}
                sx={{ maxWidth: "100px" }}
              >
                Send
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default PaymentRequest;
